export const typographyWeights = [
  { label: "Regular", value: "regular" },
  { label: "Semimedium", value: "semimedium" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
] as const;
